import { render, staticRenderFns } from "./WaterQualityQualificationRate.vue?vue&type=template&id=1be40d36&scoped=true"
import script from "./WaterQualityQualificationRate.vue?vue&type=script&lang=js"
export * from "./WaterQualityQualificationRate.vue?vue&type=script&lang=js"
import style0 from "./WaterQualityQualificationRate.vue?vue&type=style&index=0&id=1be40d36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be40d36",
  null
  
)

export default component.exports